module.exports = __webpack_public_path__ + "img/labs1_2.36863801.svg";